var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button button-primary",attrs:{"disabled":_vm.loading},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.emitClick.apply(null, arguments)}}},[(!_vm.loading)?_vm._t("default"):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',[_c('div',{staticClass:"spinner is-active"}),_vm._v(" "),_c('p',{staticClass:"screen-reader-text"},[_vm._v("Button for form disabled until request has processed.")])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./admin/src/js/components/AcButton.vue